import React, { useEffect, useState } from "react";
import MatchStats from "../common/MatchStats";
import NoDataFound from "../common/NoDataFound";
import { calculatePercentagestats } from "../../utils/generalLiveCenter";
import { loadStyles } from "../../utils/cssLoader";

const IceHockeyStats = ({
  data,
  loadCSS = true,
  dataClient = false,
  title,
}) => {
  const [clientData, setClientData] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState("all");

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS) {
      loadStyles("matchstat");
    }
  }, [loadCSS]);

  const matchStats = dataClient ? clientData : data;

  if (!matchStats) {
    return <NoDataFound />;
  }

  // Get available periods from data
  const getAvailablePeriods = () => {
    const periods = ["all"];
    if (matchStats?.p1) periods.push("p1");
    if (matchStats?.p2) periods.push("p2");
    if (matchStats?.p3) periods.push("p3");
    if (matchStats?.ot) periods.push("ot");
    return periods;
  };

  const availablePeriods = getAvailablePeriods();

  // Get stats for selected period or all
  const getStatsForPeriod = () => {
    const statsData = selectedPeriod === "all"
      ? matchStats?.stats || matchStats
      : matchStats?.[selectedPeriod]?.stats || matchStats?.[selectedPeriod];

    if (!statsData) return [];

    // Common ice hockey stats to display
    const statKeys = [
      { key: "shots_on_goal", label: "Shots on Goal" },
      { key: "shots", label: "Shots" },
      { key: "blocked_shots", label: "Blocked Shots" },
      { key: "power_plays", label: "Power Plays" },
      { key: "power_play_goals", label: "Power Play Goals" },
      { key: "penalty_minutes", label: "Penalty Minutes" },
      { key: "hits", label: "Hits" },
      { key: "faceoffs_won", label: "Faceoffs Won" },
      { key: "giveaways", label: "Giveaways" },
      { key: "takeaways", label: "Takeaways" },
      { key: "saves", label: "Saves" },
      { key: "save_percentage", label: "Save %" },
    ];

    const formattedStats = [];

    statKeys.forEach(({ key, label }) => {
      const stat = statsData[key];
      if (stat && (stat.ht !== undefined || stat.at !== undefined)) {
        const htVal = stat.ht || 0;
        const atVal = stat.at || 0;
        formattedStats.push({
          type: label,
          ht: htVal,
          at: atVal,
          htPercent: calculatePercentagestats(htVal, atVal),
          atPercent: calculatePercentagestats(atVal, htVal),
        });
      }
    });

    return formattedStats;
  };

  const stats = getStatsForPeriod();

  const periodLabels = {
    all: "All",
    p1: "P1",
    p2: "P2",
    p3: "P3",
    ot: "OT",
  };

  return (
    <div className="icehockey_stats_container">
      {title && <h1>{title}</h1>}

      {availablePeriods.length > 1 && (
        <div className="stats_filters">
          <div className="period_selector">
            {availablePeriods.map((period) => (
              <button
                key={period}
                className={`filter_button ${selectedPeriod === period ? "active" : ""}`}
                onClick={() => setSelectedPeriod(period)}
              >
                {periodLabels[period]}
              </button>
            ))}
          </div>
        </div>
      )}

      {stats.length > 0 ? (
        <div className="stats-holder">
          <MatchStats stats={stats} />
        </div>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
};

export default IceHockeyStats;
